import { createStore } from 'zustand';
export const createCoreInstanceStore = (coreInstance) => createStore(set => {
    const setCoreInstance = coreInstance => {
        set(() => ({ coreInstance }));
    };
    const actions = {
        setCoreInstance
    };
    return {
        coreInstance,
        actions
    };
});
//# sourceMappingURL=createCoreInstanceStore.js.map